var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import States from '@/modules/search/components/filterPanels/LocalizationPanel/States.vue';
import { connect } from '@/overmind';
let StatesContainer = class StatesContainer extends Vue {
    setStatesCheckbox({ filterOptionIndex, value, itemId, }) {
        // @ts-ignore TS2349: property inexistent
        this.actions.updateFilterOption({
            filterGroupId: 2,
            filterId: 21,
            filterOptionIndex,
            value,
            itemId,
        });
        // @ts-ignore TS2349: property inexistent
        this.actionsSearch.searches.buildPotentialResults();
    }
    get selectedStates() {
        // @ts-ignore TS2349: property inexistent
        return this.selectedCheckbox.filter((f) => f.queryField === 'sg_uf');
    }
};
__decorate([
    Prop({ default: () => { } })
], StatesContainer.prototype, "filter", void 0);
StatesContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        actions: actions.filters,
        actionsSearch: actions.search,
        searchTerm: state.searchTerm,
        selectedCheckbox: state.selectedCheckbox,
    }), {
        components: {
            States,
        },
    }))
], StatesContainer);
export default StatesContainer;
